import { createFileRoute } from '@tanstack/react-router'
import { VehicleNewPage } from '@/features/fleet/vehicle-new-page'

export const Route = createFileRoute('/_authenticated/fleet/new')({
  component: VehicleNewPage,
})
